import { Component, OnInit, ViewChild } from '@angular/core';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { UserService } from './shared/user.service';
import { FormGroup, FormControl } from '@angular/forms';
import { filterBy } from '@progress/kendo-data-query';
import { IOption } from 'ng-select';
import { NotificationToastService } from 'app/notification/notification-toast.service';
import { SessionService } from 'app/sessions/session.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
    gridViewAdmins:GridDataResult;
    gridViewSupervisors:GridDataResult;
    gridViewDrivers:GridDataResult;
    gridViewEmployees:GridDataResult;
    admins:any;
    supervisors:any;
    drivers:any;
    employees:any;
    branches:any;
    public pageSize = 10;
    public skipAdmins = 0;
    public skipSupervisors = 0;
    public skipDrivers = 0;
    public skipEmployees = 0;
    adminSearchForm:FormGroup;
    supervisorSearchForm:FormGroup;
    driverSearchForm:FormGroup;
    employeeSearchForm:FormGroup;
    adminsSearchResult:any;
    supervisorsSearchResult:any;
    driversSearchResult:any;
    employeesSearchResult:any;
    isSearch:boolean = false;
    branchOptions:Array<IOption>;
    adminOptions:Array<IOption>;
    driverOptions:Array<IOption>;
    supervisorOptions:Array<IOption>;
    employeeOptions:Array<IOption>;
    toDeleteUser:any;
    toDeleteUid:any;
    @ViewChild("deleteModal") deleteModal:any;
  constructor(private userService:UserService, private nf:NotificationToastService, private ss:SessionService) { }

  ngOnInit() {
    this.initializeForm();
      this.getAllBranches();
      setTimeout(() => {
        this.getAllAdmins();
        this.getAllSupervisors();
        this.getAllDrivers();
        this.getAllEmployees();
      }, 300);
  }

initializeForm()
{
  this.adminSearchForm = new FormGroup({
    name: new FormControl(''),
    branch: new FormControl(''),
  });
  this.supervisorSearchForm = new FormGroup({
    name: new FormControl(''),
    branch: new FormControl(''),
  });
  this.driverSearchForm = new FormGroup({
    name: new FormControl(''),
    branch: new FormControl(''),
  });
  this.employeeSearchForm = new FormGroup({
    name: new FormControl(''),
    branch: new FormControl(''),
  });
}
  gridView = [
      {
          "User": "Image",
          "EmployeeID": "1003",
          "Name": "Jeevan",
          "Email": "jeevan@gmail.com",
          "Phone": "9696859689",
          "Branch":"Jeddah",
          "Role": "Admin"
      },
      {
          "User": "Image",
          "EmployeeID": "1003",
          "Name": "Jeevan",
          "Email": "jeevan@gmail.com",
          "Phone": "9696859689",
          "Branch":"Jeddah",
          "Role": "Admin"
    },
    {
          "User": "Image",
          "EmployeeID": "1003",
          "Name": "Jeevan",
          "Email": "jeevan@gmail.com",
          "Phone": "9696859689",
          "Branch":"Jeddah",
          "Role": "Admin"
    }
]
getAllAdmins()
{
    var x = this.userService.getAllUser();
    x.snapshotChanges().subscribe(item=>{
        this.admins = [];
        this.adminOptions = [];
        item.forEach(element =>{
          var y = element.payload.toJSON();
          if(element.payload.child("role").val() == "admin" || element.payload.child("role").val() == "super admin")
          {
            if(element.payload.child("boardingStatus").val() == "onboard")
            {
            y["$key"] = element.key;
            y["branchName"] = this.branches[element.payload.child("branch").val()];
            this.admins.push(y);
            this.adminOptions.push({label: String(element.payload.child("name").val()), value: String(element.payload.child("employeeId").val())});
            }
          }
        });
        this.loadItemsFromAdmins();
      });
}
getAllDrivers()
{
    var x = this.userService.getAllDrivers();
    x.snapshotChanges().subscribe(item=>{
        this.drivers = [];
        this.driverOptions = [];
        item.forEach(element =>{
          if(element.payload.child("boardingStatus").val() == "onboard")
          {
            var y = element.payload.toJSON();
            y["$key"] = element.key;
            y["branchName"] = this.branches[element.payload.child("branch").val()];
            this.drivers.push(y);
            this.driverOptions.push({label: String(element.payload.child("name").val()), value: String(element.payload.child("employeeId").val())});
          }
          });
        this.loadItemsFromDrivers();
      });
}
getAllSupervisors()
{
    var x = this.userService.getAllSupervisors();
    x.snapshotChanges().subscribe(item=>{
        this.supervisors = [];
        this.supervisorOptions = [];
        item.forEach(element =>{
          if(element.payload.child("boardingStatus").val() == "onboard")
          {
            var y = element.payload.toJSON();
            y["$key"] = element.key;
            y["branchName"] = this.branches[element.payload.child("branch").val()];
            this.supervisors.push(y);
            this.supervisorOptions.push({label: String(element.payload.child("name").val()), value: String(element.payload.child("employeeId").val())});
          }
          });
        this.loadItemsFromSupervisors();
      });
}
getAllEmployees()
{
  var x = this.userService.getAllEmployees();
    x.snapshotChanges().subscribe(item=>{
        this.employees = [];
        this.employeeOptions = [];
        item.forEach(element =>{
          if(element.payload.child("boardingStatus").val() == "onboard")
          {
            var y = element.payload.toJSON();
            y["$key"] = element.key;
            y["branchName"] = this.branches[element.payload.child("branch").val()];
            this.employees.push(y);
            this.employeeOptions.push({label: String(element.payload.child("name").val()), value: String(element.payload.child("employeeId").val())});
          }
          });
        this.loadItemsFromEmployees();
      });
}
getAllBranches()
{
    var x = this.userService.getAllBranches();
    x.snapshotChanges().subscribe(item=>{
        this.branches = [];
        this.branchOptions = [];
        item.forEach(element =>{
            this.branches[element.key] = element.payload.child("name").val();
            this.branchOptions.push({label: String(element.payload.child("name").val()), value: String(element.key)});
        });
      }); 
}
private loadItemsFromAdmins():void{
  if(this.isSearch)
  {
    this.gridViewAdmins = {
      data: this.adminsSearchResult.slice(this.skipAdmins, this.skipAdmins + this.pageSize),
      total: this.adminsSearchResult.length
    };
  }
  else
  {
    this.gridViewAdmins = {
      data: this.admins.slice(this.skipAdmins, this.skipAdmins + this.pageSize),
      total: this.admins.length
    };
  }
  }
  private loadItemsFromSupervisors():void{
    if(this.isSearch)
    {
      this.gridViewSupervisors = {
        data: this.supervisorsSearchResult.slice(this.skipSupervisors, this.skipSupervisors + this.pageSize),
        total: this.supervisorsSearchResult.length
      };
    }
    else
    {
      this.gridViewSupervisors = {
        data: this.supervisors.slice(this.skipSupervisors, this.skipSupervisors + this.pageSize),
        total: this.supervisors.length
      };
    }
  }
  private loadItemsFromDrivers():void{
    if(this.isSearch)
    {
      this.gridViewDrivers = {
        data: this.driversSearchResult.slice(this.skipDrivers, this.skipDrivers + this.pageSize),
        total: this.driversSearchResult.length
      };
    }
    else
    {
      this.gridViewDrivers = {
        data: this.drivers.slice(this.skipDrivers, this.skipDrivers + this.pageSize),
        total: this.drivers.length
      };
    }
  }
  loadItemsFromEmployees()
  {
    if(this.isSearch)
    {
      this.gridViewEmployees = {
        data: this.employeesSearchResult.slice(this.skipEmployees, this.skipEmployees + this.pageSize),
        total: this.employeesSearchResult.length
      };
    }
    else
    {
      this.gridViewEmployees = {
        data: this.employees.slice(this.skipEmployees, this.skipEmployees + this.pageSize),
        total: this.employees.length
      };
    }
  }
  public pageChange(event: PageChangeEvent, from:String): void {
    switch(from)
    {
        case "admin":
        this.skipAdmins = event.skip;
        this.loadItemsFromAdmins();
        break;
        case "supervisor":
        this.skipSupervisors = event.skip;
        this.loadItemsFromSupervisors();
        break;
        case "driver":
        this.skipDrivers = event.skip;
        this.loadItemsFromDrivers();
        break;
        case "employee":
        this.skipEmployees = event.skip;
        this.loadItemsFromEmployees();
        break;
    }
  }

  onSubmitSearch(from)
  {
    console.log("onSubmitSearch",this.adminSearchForm.value);
    this.isSearch =true;
    switch(from){
      case 'admins':
      this.adminsSearchResult = filterBy(this.admins, {
        logic: 'or',
        filters: [
            { field: "branch", operator: "eq", value: this.adminSearchForm.value.branch},
            { field: "employeeId", operator: "eq", value: this.adminSearchForm.value.name}
        ]
    });
    this.loadItemsFromAdmins();
      break;
      case 'supervisors':
      this.supervisorsSearchResult = filterBy(this.supervisors, {
        logic: 'or',
        filters: [
            { field: "branch", operator: "eq", value: this.supervisorSearchForm.value.branch},
            { field: "employeeId", operator: "eq", value: this.supervisorSearchForm.value.name}
        ]
    });
    this.loadItemsFromSupervisors();
      break;
      case 'drivers':
      this.driversSearchResult = filterBy(this.drivers, {
        logic: 'or',
        filters: [
            { field: "branch", operator: "eq", value: this.driverSearchForm.value.branch},
            { field: "employeeId", operator: "eq", value: this.driverSearchForm.value.name}
        ]
    });
  
    this.loadItemsFromDrivers();
      break;
      case 'employees':
      this.employeesSearchResult = filterBy(this.employees, {
        logic: 'or',
        filters: [
            { field: "branch", operator: "eq", value: this.employeeSearchForm.value.branch},
            { field: "employeeId", operator: "eq", value: this.employeeSearchForm.value.name}
        ]
    });
  
    this.loadItemsFromEmployees();
      break;
    }
  }
    onClearSearch(from)
    {
      this.isSearch = false;
      switch(from){
        case 'admins':
        this.adminSearchForm.reset();
        this.loadItemsFromAdmins();
        break;
        case 'supervisors':
        this.supervisorSearchForm.reset();
        this.loadItemsFromSupervisors();
        break;
        case 'drivers':
        this.driverSearchForm.reset();
        this.loadItemsFromDrivers();
        break;
        case 'employees':
        this.employeeSearchForm.reset();
        this.loadItemsFromEmployees();
        break;
      }
    }
    onDeleteEmployee(uid,name)
    {
      this.toDeleteUid = uid;
      this.toDeleteUser = name;
      this.deleteModal.show();
    }
    deleteUser()
    {
      this.userService.deleteEmployee(this.toDeleteUid).then(()=>{
        //alert("deleted from db");
        this.userService.updateDeleteEmployeeToDeleteInAuth(this.toDeleteUid).then(()=>{
          //alert("deleted from auth");
          this.toDeleteUser = null;
          this.toDeleteUid = null;
          this.nf.addToast({title:'Success', msg:'Employee account has been deleted', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
          this.deleteModal.hide();
        });
      });
    }
    onChange(event, id) {
      if(event)
      {
        //console.log("this is active");
          this.userService.updateStatus(id,"1").then(
            (success) => {
              //console.log("status updated");
            });
      }
      else{
        //console.log("this is inactive");
        this.userService.updateStatus(id,"0").then(
          (success) => {
            //console.log("status updated");
          });
      }
    }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/users/users.component.ts